<pp-side-panel-menu-button
  [ppText]="'sites_and_accounts' | ppTranslate"
  [ppDataTarget]="'Accounts & Sites icon'"
  ppDataTest="sitesMenuItem"
  [ppIconSrc]="EIconPath.SIDE_PANEL_FOLDER"
  [ppActive]="sidePanel.rightPanelExpanded || (sidePanel.expanded && !ppIsMobile)"
  [ppTogglesPanel]="true"
  [ppDisabled]="ppDisabled"
  (ppAction)="toggleRightPanel()"
></pp-side-panel-menu-button>
